// @ts-nocheck

import { BILLING_ACCOUNT } from '../actions/SubscriptionActions';
import { reducerWrapper } from '../support/utils';
import type { BillingAccountReducer } from '../types/billingAccountTypes';
const INIT_STATE: BillingAccountReducer = {
  loading: false,
  error: null,
  data: null,
};

function Handler(state: BillingAccountReducer, action) {
  let { data } = action;

  switch (action.type) {
    case BILLING_ACCOUNT.response:
      data = data || {};
      return Object.assign({}, state, {
        loading: false,
        data,
      });

    default:
      return state;
  }
}

const BillingAccount = reducerWrapper(INIT_STATE, Handler, {
  request: [BILLING_ACCOUNT],
  error: [BILLING_ACCOUNT],
  resetOn: ['APP_CHANGE'],
});
export default BillingAccount;
